import React from 'react';
import ResourceName from 'admin/components/common/ResourceEditor/ResourceName';

export default function DesignPresetName({
	name,
	path,
	kind,
	disabled,
	onRename,
}: {
	name: string;
	path: string[];
	kind: 'folder' | 'preset';
	disabled?: boolean;
	onRename: (name: string) => void;
}) {
	return (
		<ResourceName
			name={name}
			label={kind === 'folder' ? 'Folder' : 'Preset'}
			title={path.join('/')}
			disabled={disabled}
			validateName={draft => (draft.includes('/') ? `Enter a single ${kind} name without /.` : undefined)}
			onRename={onRename}
		/>
	);
}
